import {ChatDocumentType} from '@Libraries/chat-document.types';

export const FILENAME_MAX_CHARS = 18;

export const ICON_CLASS_BY_TYPE: Record<ChatDocumentType, string> = {
  [ChatDocumentType.PDF]: 'icon-file-pdf',
  [ChatDocumentType.CSV]: 'icon-file-csv',
  [ChatDocumentType.TXT]: 'icon-doc',
  [ChatDocumentType.XLSX]: 'icon-doc',
  [ChatDocumentType.DOCX]: 'icon-doc',
};

export enum DocumentChipStep {
  UPLOADING = 'uploading',
  READING = 'reading',
}

export const STEP_LABEL_KEY: Record<DocumentChipStep, string> = {
  [DocumentChipStep.UPLOADING]: 'pmwjs_ai_chat_document_uploading',
  [DocumentChipStep.READING]: 'pmwjs_ai_chat_document_reading',
};

export const SECONDS_BEFORE_SHOWING_STEP_TIME = 5;

interface DocumentChipFailure {
  summary: string;
  message: string;
}

export interface DocumentChipProps {
  filename: string;
  documentType: ChatDocumentType;
  onClick: VoidFunction;
  isDisabled?: boolean;
  step?: DocumentChipStep;
  failure?: DocumentChipFailure;
}
